<template src='./Sugerencias.html'></template>

<script>
import Vue from "vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { serverBus } from "../../../main";
import metodos_comunes from '../../../js/metodos_comunes';

export default {
  data() {
    return {
      // search:"",
      copiaSugerencias:"",
      swiperRender: 0,
      slideMaximo: 2,
      swiperOption: {
        initialSlide: 0,
        slidesPerColumn: 1,
        slidesPerView: 2,
        spaceBetween: 8, // Espaciado entre sugerencias, medido en px solamente
        simulateTouch: false, // Quita la posiblidad de navegar en el carrusel arrastrando con el mouse
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },

  beforeUpdate() {
    this.cambiarSlidesPerView();
  },
  watch:{
    sugerencias() {
      this.copiaSugerencias = this.sugerencias;
    },
    mensaje() {
      this.filtroSugerencias();
    }
  },
  methods: {
    filtroSugerencias() {
      const buscar = metodos_comunes.reemplazarCaracteresEspeciales(this.mensaje + '');
      this.copiaSugerencias = this.sugerencias;
      const array = this.copiaSugerencias.filter(sugerenciasBuscar => {
        if(sugerenciasBuscar && metodos_comunes.reemplazarCaracteresEspeciales(sugerenciasBuscar + '').includes(buscar)
        ){
          return sugerenciasBuscar
        }
      });
      this.copiaSugerencias = array;
      this.cambiarSlidesPerView();
    },
    /* Funcion para redimensionar las sugerencias dependiendo de la cantidad de sugerencias */
    cambiarSlidesPerView() {
      let slideDefecto = this.copiaSugerencias.length;
       if (slideDefecto > this.slideMaximo) {
        slideDefecto = this.slideMaximo;
      }
      this.swiperOption.slidesPerView = slideDefecto;
      this.$refs.swip.swiper.slideTo(0, 1000, false);
      
      this.forceRerender();
      this.sugerenciasResize(slideDefecto);
    },

    sugerenciasResize: function(slides) {
      const self = this;
      setTimeout(function() {
        Array.from(
          document.getElementsByClassName("sugerencias"),
          e => (e.style.minWidth = `${100 / self.slideMaximo / slides}vw`)
        );
      }, 1);
    },

    seleccionSugerencia: function(sugerenciaSeleccionada) {
      this.$store.dispatch("setCargando", true);
      serverBus.$emit("sugerenciaSeleccionada", sugerenciaSeleccionada);
      // this.search = "";
    },

    forceRerender() {
      this.swiperRender += 1;
      this.$refs.swip.options.slidesPerColumn = this.copiaSugerencias.length <= 5 ? 1 : 2;
      let tamano = screen.width;
      
      // this.$refs.swip.options.slidesPerView = screen.width == 1366 ? 2 : 3;
      // this.$refs.swip.slideMaximo = screen.width == 1366 ? 2 : 3;
    },
  },
 
  components: {
    swiper,
    swiperSlide
  },
  
  props: {
    sugerencias: {
      type: Array,
      required: true
    },
    mensaje: {
      type: String,
    }
  }
};
</script>
<style lang="scss" src='./Sugerencias.scss'>
</style>


// WEBPACK FOOTER //
// src/components/Chatbox/Sugerencias/Sugerencias.vue